import { EntityStatusBadge } from '@frontend/components/badge';
import { EquipmentStateName } from '@frontend/equipment/types';
import React from 'react';

import { useEquipmentStateBadge } from './equipment-state-badge.controller';

const ID = 'equipment-state-badge';

export interface EquipmentStateBadgeProps {
    state: EquipmentStateName;
}

export const EquipmentStateBadge = (props: EquipmentStateBadgeProps) => {
    const viewProps = useEquipmentStateBadge(props);
    return (
        <EntityStatusBadge
            id={ID}
            label={viewProps.displayName}
            variant={viewProps.variant}
        />
    );
};
